export default {
    data() {
        return {
            slide: null,
            slideAbsolute: null,
            SLIDE_X_LEFT: 'slide-modal-content-l',
            SLIDE_X_RIGHT: 'slide-modal-content-r',
            SLIDE_X_LEFT_ABSOLUTE: 'slide-modal-content-l-absolute',
            SLIDE_X_RIGHT_ABSOLUTE: 'slide-modal-content-r-absolute',
        }
    },
    methods: {
        setSlideLeft() {
            return new Promise((resolve) => {
                this.slide = this.SLIDE_X_LEFT
                this.slideAbsolute = this.SLIDE_X_LEFT_ABSOLUTE
                setTimeout(() => {
                    resolve()
                }, 100)
            })
        },
        setSlideRight() {
            return new Promise((resolve) => {
                this.slide = this.SLIDE_X_RIGHT
                this.slideAbsolute = this.SLIDE_X_RIGHT_ABSOLUTE
                setTimeout(() => {
                    resolve()
                }, 100)
            })
        },
    },
}
